import { useDispatch, useSelector } from 'react-redux';

import {
  setOrgName,
  setPermissions,
  setsubAdminBoolean,
  setUserTheme,
  setAccessLogsCreatedOnFilter,
  setAccessLogsNameSearch,
  setAuditLogsCreatedOnFilter,
  setAuditLogsNameSearch,
} from '../state/reducers/common';
/**
 * Custom hook for accessing and dispatching common actions at the application level.
 *
 * @returns {{
 *   dispatch: Function,
 *   common: Object,
 * }} Object containing functions and state variables for common actions.
 * @example
 * const { dispatch, common } = useCommon();
 */

export default function useCommon() {
  const dispatch = useDispatch();
  const { common } = useSelector((state) => state);
  return {
    dispatch,
    common,
    setOrgName,
    setPermissions,
    setsubAdminBoolean,
    setUserTheme,
    setAccessLogsCreatedOnFilter,
    setAccessLogsNameSearch,
    setAuditLogsCreatedOnFilter,
    setAuditLogsNameSearch,
  };
}
